import { LandingContent } from "./types";
import {
  GiMirrorMirror,
  GiTeacher,
  GiStopwatch,
  GiNotebook,
  GiChatBubble,
} from "react-icons/gi";
import { FaQuestion } from "react-icons/fa";
import workshopImage from "../../assets/images/workshop.jpg"


export const workshopContent: LandingContent = {
  seo: {
    title: "Workshop időpontfoglalás egyszerűen | Wobble",
    description:
      "Online időpontfoglaló rendszer workshopot, tréninget vagy tanfolyamot tartó szolgáltatóknak. Kevesebb adminisztráció, több résztvevő – próbáld ki a Wobble-t!",
    ogTitle: "Wobble - Időpontfoglalás workshopokhoz",
    ogDescription:
      "Automatizált foglalási rendszer, amivel egyszerűbbé válik a jelentkezéskezelés és több időd marad a tartalomra, amit átadsz.",
    keywords:
      "workshop, tanfolyam, tréning, online jelentkezés, foglalási rendszer, oktató, szolgáltató, Wobble",
    image: "../assets/mockup_workshop.png",
  },
  header: {
    heading: "Időpontfoglaló rendszer workshopot tartóknak",
    subheading:
      "Legyen könnyű jelentkezni, átlátható a résztvevők listája, és automatikus a visszaigazolás.",
    highlightText: "Wobble időpontfoglaló rendszer workshop- és tréningvezetőknek",
  },
  problems: {
    title: "Ismerősek ezek a kihívások?",
    features: [
      { icon: GiNotebook, text: "Manuálisan vezeted a jelentkezéseket, és folyton keresgélni kell?" },
      { icon: GiChatBubble, text: "Sok üzenetváltás, mire valaki lefoglal egy helyet?" },
      { icon: GiStopwatch, text: "Nem kapsz elég gyorsan visszajelzést a résztvevőktől?" },
      { icon: FaQuestion, text: "Ugyanazokat a kérdéseket kapod újra és újra az eseményről?" },
      { icon: GiTeacher, text: "Nehezen követed, ki mire jelentkezett, ki fizetett már?" },
    ],
    summaryText:
      "A Wobble leveszi a válladról az adminisztrációt, hogy az energiád az élmény átadására fókuszálhasd.",
    cta: {
      href: "https://app.wobble.hu/signup_page",
      label: "Kipróbálom ingyen",
    },
    imageSrc: workshopImage,
    imageAlt: "Workshop vezető munka közben",
  },
  whyDigitalize: {
    title: "Miért éri meg digitalizálni a jelentkezéseket?",
    features: [
      { icon: GiMirrorMirror, text: "A résztvevők online jelentkeznének - add meg nekik a lehetőséget" },
      { icon: GiStopwatch, text: "A foglalások 0-24 elérhetők, nem kell külön egyeztetni" },
      { icon: GiChatBubble, text: "Automatikus visszaigazolás és emlékeztetők" },
      { icon: GiNotebook, text: "Minden résztvevő, esemény és státusz egy helyen követhető" },
      { icon: GiTeacher, text: "Workshopok, időpontok, elérhetőségek, speciális opciók beállítása néhány kattintással" },
    ],
  },
  whyTheyLove: {
    title: "Hogyan könnyíti meg a munkád a Wobble?",
    imageSrc: "../assets/mockup_workshop.png",
    imageAlt: "Workshop online foglalás",
    features: [
      { icon: GiMirrorMirror, text: "Modern, letisztult jelentkezési felület" },
      { icon: GiTeacher, text: "Többféle esemény létrehozása - csoportos, egyéni, ismétlődő alkalmak" },
      { icon: GiStopwatch, text: "Automatizált e-mailek, így nem marad el a visszajelzés sem" },
      { icon: GiChatBubble, text: "Kérdőív foglaláskor - így előre minden megtudsz ügyfeleidről" },
      { icon: GiNotebook, text: "Egyszerű adminisztráció - több idő az értékteremtésre" },
    ],
  },
  trial: {
    title: "🎓 Próbáld ki 30 napig ingyen!",
    subtitle: "Nincs kártyaadat, nincs kockázat - csak egy rendszer, amivel könnyebbé válik a jelentkezéskezelés.",
    cta: {
      href: "https://app.wobble.hu/signup_page",
      label: "Regisztrálok most",
    },
  },
};
